export default "__VITE_ASSET__a6f09d48__"